import { render, staticRenderFns } from "./TheMapRestaurants.vue?vue&type=template&id=10ef418f&scoped=true&"
import script from "./TheMapRestaurants.vue?vue&type=script&lang=ts&"
export * from "./TheMapRestaurants.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ef418f",
  null
  
)

export default component.exports